import React from "react";
import {
  Database,
  Network,
  LayoutDashboard,
  BrainCircuit,
  Calculator,
  Users,
  GitBranch,
  GitGraph,
  BookMarked,
  Map,
  Circle,
} from "lucide-react";
import data from "../../../_data/home.json";

const iconMap = {
  Database,
  Network,
  LayoutDashboard,
  BrainCircuit,
  Calculator,
  Users,
  GitBranch,
  GitGraph,
  BookMarked,
  Map,
};

function getIcon(iconName) {
  return iconMap[iconName] || Circle;
}

function ToneIcon({ tone }) {
  return <span className={`home-toneIcon tone-${tone || "slate"}`} aria-hidden="true" />;
}

export default function Home() {
  const hero = data?.hero;
  const what = data?.what;
  const quick = data?.quickLinks;

  if (!hero || !what || !quick) {
    return (
      <section className="home">
        <div className="home-empty">Home data not found.</div>
      </section>
    );
  }

  return (
    <section className="home" aria-label="Home">
      <div className="home-hero">
        <div className="home-heroLeft">
          <h1 className="home-heroTitle">{hero.title}</h1>
          <p className="home-heroDesc">{hero.description}</p>

          <div className="home-heroActions">
            {(hero.actions || []).map((a) => (
              <a
                key={a.label}
                className={`home-btn ${a.variant === "solid" ? "is-solid" : "is-outline"}`}
                href={a.href}
              >
                {a.label}
              </a>
            ))}
          </div>
        </div>
      </div>

      <section className="home-section" aria-labelledby="whatTitle">
        <h2 id="whatTitle" className="home-h2">
          {what.title.replace("ITS does", "")}
          <span className="home-accent">ITS</span>
          {what.title.replace("What ITS", "").replace("does", " does")}
        </h2>
        <p className="home-sub">{what.subtitle}</p>

        <div className="home-cards">
          {(what.cards || []).map((c) => {
            const CardIcon = getIcon(c.icon);
            return (
              <article key={c.title} className={`home-card ${c.accent ? "is-accent" : ""}`}>
                <div className="home-cardTop">
                  <span className="home-cardIcon" aria-hidden="true">
                    <CardIcon className="home-cardIconSvg" size={20} />
                  </span>
                </div>

                <h3 className="home-cardTitle">{c.title}</h3>
                <p className="home-cardDesc">{c.description}</p>
              </article>
            );
          })}
        </div>
      </section>

      <section className="home-section" aria-labelledby="quickTitle">
        <h2 id="quickTitle" className="home-h2">
          {quick.title}
        </h2>
        <p className="home-sub">{quick.subtitle}</p>

        <div className="home-quickGrid">
          {(quick.items || []).map((i) => {
            const QuickIcon = getIcon(i.icon);
            return (
              <a
                key={i.title}
                className={`home-quickItem tone-${i.tone || "slate"} ${i.accent ? "is-accent" : ""}`}
                href={i.href}
              >
                <span className="home-quickIcon" aria-hidden="true">
                  <QuickIcon className="home-quickIconSvg" size={22} />
                </span>

                <div className="home-quickTitle">{i.title}</div>
                <div className="home-quickDesc">{i.description}</div>
              </a>
            );
          })}
        </div>
      </section>
    </section>
  );
}
